<div class="sdw" role="alert">
    <span class="sdw__icon" aria-hidden="true">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round">
            <path d="M12 9v5" />
            <path d="M12 17.5v.01" />
        </svg>
    </span>
    <div class="sdw__body">
        <div class="sdw__title">Datos de prueba · ambiente de staging</div>
        <div class="sdw__text">Esta cuenta es del ambiente de calidad de Banesco, no la cuenta real de Fina. El pago se verifica igual que en producción: con tus datos y el monto de la cuota.</div>
        <div *ngIf="detail" class="sdw__detail">{{ detail }}</div>
        <ng-content></ng-content>
    </div>
</div>
